/**
 * @file tag
 * @author zhaomiaoyuan
 */
import React, {Fragment} from 'react';
import iconError from '../../asset/img/icons/icon-error.svg';
import iconSuccess from '../../asset/img/icons/icon-success.svg';
import './index.less';

interface Props {
    color?: string;
    children: string;
    style?: any
}
export default function ZTag(props: Props) {
    const {
        color,
        children,
        style
    } = props;
    const type = color || 'success';
    const imgs = {
        'success': iconSuccess,
        'error': iconError
    };
    return (
        <Fragment>
            <span className={`z-tag z-tag-${type}`}
                style={style}
            >
                <img src={imgs[type]}/>
                <span>{children}</span>
            </span>
        </Fragment>
    );
}
